import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { isloading } from "../redux/reducer/LoadingReducer";
import axios from "axios";
import AxiosInstance from "../Utility/AxiosInstance";
import { handleAxiosError } from "../Utility/handleAxiosError";
import BaseUrl from "../../base-api";
import { useLocation } from "react-router-dom";
const ListofAuthorities = () => {
  const location = useLocation();
  const [images, setImages] = useState([]);
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await AxiosInstance.post(
          `${BaseUrl}/api/authorities/web/getAll`,
          { location: "All" }
        );

        if (res.data.status === 200) {
          setImages(res.data.data);
        } else {
          console.error(res.data.message || "Failed to load images.");
        }
      } catch (error) {
        handleAxiosError(error);
      } finally {
        dispatch(isloading(false));
      }
    };

    if (location.pathname) fetchData();
  }, [location.pathname]);

  useEffect(() => {
    dispatch(isloading(true));
  }, []);
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>List of Authorities</h5>
      </div>

      <div className="about-box p-4 rounded shadow-lg ">
        <div className="table-responsive">
          <table className="table table-striped table-bordered">
            <thead>
              <tr>
                <th>FIRST APPELLATE AUTHORITY</th>
                <th>COMPANY SECRETARY</th>
              </tr>
            </thead>

            <tbody>
              {Object.entries(images).map(([district, officers]) => (
                <>
                  <tr key={district}>
                    <td className="bold center-align" colspan="2" style={{fontWeight:600}}>
                      {district.toUpperCase()}
                    </td>
                  </tr>
                  {officers.map((officer, index) => (
                    <tr key={officer.key || index}>
                      <td>{officer.role || "-"}</td>
                      <td>{officer.designation || "-"}</td>
                    </tr>
                  ))}
                </>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ListofAuthorities;
